import { useMountEffect, type IFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { type GroupLayer } from '../..';
import { GroupLayerHotkeyType } from '../../type';

export function usePackHotkey(framework: IFramework) {
    useMountEffect(() => {
        const { $t } = getLocaleStore();
        const tryGetGroupLayer = () => {
            const groupLayer = framework.service.registration.getInstance<GroupLayer>('GroupLayer');
            if (!groupLayer) {
                throw new Error('GroupLayer is not found');
            }
            return groupLayer;
        };

        framework.service.hotkey.register({
            name: $t((v) => v.Text_Group),
            win: 'Ctrl G',
            mac: '⌘ G',
            key: GroupLayerHotkeyType.PACK,
            processors: [
                {
                    press: ['Ctrl+G', 'Command+G'],
                    fn: () => {
                        const layerId = framework.service.frame.getActiveLayer()?.id;
                        if (layerId) {
                            tryGetGroupLayer().pack(layerId);
                        }
                    },
                },
            ],
        });
    });
}
